import { calcAdt, calcGpAdt } from '@/util/calcAdt'
import { getRestGroupGoods } from '@/apis/shopcart'
import { arr2map } from '@/plugins/utils'
import { getJapanTime } from '@/util/common'
import { getBatchStock } from '@/apis/stock'
import { sourceCountryRef } from '@/views/shopcart/country'

interface Sku {
  onTheWayAvailableNum:number
  onTheWayStockQuantity: number
  originalstockQuantity: number
  checked: boolean
  cartId: number|string
  productType:number
  productCode: string
  productPriceLadderList: any[]
  productSellPrice: number
  orderQuantity: number
  stockQuantity: number
  restQuantity:number
  productStatus: number
  buyQuantity: number
  valueQuantity: number
  unitNums: number
  lack?: boolean
  price: number
  totalPrice: number
  /** 订单价值 */
  valuePrice: number
  adtPrice: number
  cartAdditionList: any[]
  shopProductSku: string
  // 是否有转结待组合商品
  matchStore?: any
  shitProp?: any
  minOrderQuantity: any
  combinationProductSku?: string
  combinationProductItemList: Sku[],
  // 商品账期
  paymentDetail?: string;
  // 商品账期金额
  curPdtPirce?: number;
  livePriceFlag?: number
  channel?: number
  consignPrice?: number
  isOnePsale?: boolean
  onePsaleLack?: boolean
  noPriceLadder?: boolean
  // 一手数量
  batchNumber?: number
  handLack?: boolean
  productSku: string
}

interface Shop {
  cartList: Sku[]
  shitProp?: any
}

// 需要传全部Sku和过滤的map
export default (
  skulist: any[],
  listCheckMap: any,
  is2b = false
): Promise<void[]> => {
  const spuMap: any = {}
  // 记录选中的sku数量
  const skuMap:any = {}
  skulist.forEach((item: Sku) => {
    // 区分字段名
    item.buyQuantity = listCheckMap
      ? Math.max(0, item.orderQuantity - (is2b ? (item.matchStore ? item.stockQuantity : 0) : item.stockQuantity))
      : item.unitNums

    const {
      productCode,
      cartId,
      productPriceLadderList,
      buyQuantity,
      minOrderQuantity,
      channel,
      productSellPrice,
      noPriceLadder,
      productSku
    } = item
    if (!productCode) return
    if (!spuMap[productCode]) {
      spuMap[productCode] = {
        productPriceLadderList,
        minOrderQuantity,
        count: 0,
        channel,
        productSellPrice,
        liveCount: 0,
        noPriceLadder
      }
    }
    if (!skuMap[productSku]) {
      skuMap[productSku] = {
        // 剔除直播商品的数量
        liveCount: 0
      }
    }
    if (!spuMap[productCode].productPriceLadderList) {
      spuMap[productCode].productPriceLadderList = productPriceLadderList
    }

    // 如果需要选中才计算当前spu的数量
    if (listCheckMap) {
      // 选中才计算阶梯价。。。此处判断是否直播商品
      if (listCheckMap[cartId]) {
        spuMap[productCode].count += buyQuantity
        // 剔除直播商品的数量
        spuMap[productCode].liveCount += item.livePriceFlag ? 0 : buyQuantity
        skuMap[productSku].liveCount += item.livePriceFlag ? 0 : buyQuantity
      }
    } else {
      spuMap[productCode].count += buyQuantity
      spuMap[productCode].liveCount += item.livePriceFlag ? 0 : buyQuantity
    }
  })
  Object.values(spuMap).forEach((spu: any) => {
    // 有价格区间并且不是直播商品走阶梯价
    if (!spu.noPriceLadder && spu.livePriceFlag !== 1 && spu.productPriceLadderList?.length > 0) {
      spu.productPriceLadderList?.forEach(({ count, price }: any) => {
        if (spu.liveCount >= count) {
          spu.price = price
        }
      })
      if (!spu.price) {
        spu.price = spu.channel === 5 ? spu.productSellPrice : spu.productPriceLadderList?.[0].price
      }
    }
  })
  return Promise.all(
    skulist.map((item: Sku) => {
      const spu = spuMap[item.productCode] || {}
      const skuCount = skuMap[item.productSku]?.liveCount ?? 0
      // 是否满足起订量
      const isMeetMinimum = (spu.count >= spu.minOrderQuantity)
      // 只有在发到库存才验证起订量
      // 注意:如果子商品匹配了落单数量，会存在 buyQuantity 为 0 的情况，这时候不需要验证起订量
      // 组合子商品囤货不校验起订量，在confirmorder校验
      if (is2b && listCheckMap[item.cartId] && spu && item.buyQuantity > 0 && !item.combinationProductSku) {
        item.lack = spu.count < spu.minOrderQuantity
      } else {
        // 直发的线下商品需要校验起订量
        item.lack = spu.channel === 5 && listCheckMap?.[item.cartId] && item.buyQuantity > 0 ? spu.count < spu.minOrderQuantity : false
      }
      if (item.isOnePsale) {
        // 囤货不满足起订量的一件代发商品起批价等于一件代发价相同时不展示
        item.onePsaleLack = item.lack && (item.productPriceLadderList[1].price < item.productPriceLadderList[0].price)
        item.lack = false
      }
      // 囤货 购买数量不是一手数量的倍数时提示
      if (is2b && listCheckMap[item.cartId] && (skuCount % (item.batchNumber || 1) > 0)) {
        item.handLack = true
      } else {
        item.handLack = false
      }
      // 直播商品不取区间价 > 一件代发不满足起订量时取sku价格 直播优先
      item.price = item.livePriceFlag === 1 ? item.productSellPrice : (!isMeetMinimum && item.isOnePsale) ? item.consignPrice : spu?.price ?? item.productSellPrice
      item.totalPrice = item.price * item.buyQuantity
      item.valuePrice = item.price * (item.valueQuantity ? item.valueQuantity : item.orderQuantity)
      const paymentDetail = JSON.parse(item.paymentDetail as string || '[]')
      // 计算组合商品账期价格
      if (paymentDetail?.length) {
        item.curPdtPirce = Number((item.totalPrice * paymentDetail[0].paymentPeriod).toFixed(2))
      } else {
        item.curPdtPirce = item.totalPrice
      }
      // 计算附加费
      return calcAdt(item, sourceCountryRef.value).then((res) => {
        item.adtPrice = res ?? 0
      })
    })
  )
}

// 购物车数据处理
export const flatCart = async (
  list: any,
  listCheckMap: any,
  mode: any,
  isUseOnTheWayStock = false
): Promise<any[]> => {
  // 组合商品
  const group: any = []
  const groupGoods: any = []
  // 用于分配库存
  const stockMap:Record<string, any> = {}
  //
  const getSubStock = async () => {
    // 如果是囤货则不计算子商品库存，否则会和转接数冲突
    if (mode === 0) return
    const subProduct:any[] = []
    list.forEach((shop:Shop) => {
      const { cartList } = shop
      cartList.forEach(v => {
        if (v.productType === 3) {
          if (v.combinationProductItemList?.length) {
            subProduct.push(...v.combinationProductItemList)
          }
        }
      })
    })
    const batch = new Set(subProduct.map(v => v.shopProductSku))
    if (batch.size) {
      const stockMap = await getBatchStock([...batch]).then((res:any) => res.data?.shopProductSkuStockMap ?? {})
      subProduct.forEach(comItem => {
        const originalstockQuantity = stockMap[comItem.shopProductSku] ?? 0
        comItem.originalstockQuantity = comItem.stockQuantity = originalstockQuantity
      })
    }
  }

  // 计算库存数
  const calcStockQty = (v:Sku, id:string|number) => {
    if (v.shopProductSku) {
      if (!stockMap[v.shopProductSku]) {
        stockMap[v.shopProductSku] = { total: 0, use: {}, stock: '' }
      }
      // 子商品存在undefined
      v.originalstockQuantity = v.originalstockQuantity ?? 0
      // 是否使用在途
      if (isUseOnTheWayStock) {
        v.onTheWayStockQuantity = v.originalstockQuantity + (v.onTheWayAvailableNum ?? 0)
      } else {
        v.onTheWayStockQuantity = v.originalstockQuantity
      }
      // 是否已返回库存数
      if (stockMap[v.shopProductSku].total < v.onTheWayStockQuantity) {
        // 当 onTheWayStockQuantity>stockMap，说明使用在途，这时同步更新 stockMap
        stockMap[v.shopProductSku].total = v.onTheWayStockQuantity ?? 0
      } else if (!stockMap[v.shopProductSku].total) {
        // 普通商品有 onTheWayStockQuantity，更新stockMap
        stockMap[v.shopProductSku].total = v.onTheWayStockQuantity
      }
      // 如果选中 计算使用数
      if (listCheckMap[id]) {
        stockMap[v.shopProductSku].use[id] = v.orderQuantity
      } else {
        stockMap[v.shopProductSku].use[id] = 0
      }
    }
  }
  // 重新设置 stockQuantity
  const deviceStockQty = (v:Sku) => {
    const cartId = v.cartId
    const stock = stockMap[v.shopProductSku]
    // 如果选中时
    if (listCheckMap[cartId]) {
      if (stock) {
        const { total, use } = stock
        const qty = Math.min(use[cartId], total)
        // 使用库存数
        v.stockQuantity = qty
        // 剩余库存数
        stock.total = Math.max(0, total - qty)
      }
    } else {
      // 如果未勾选则库存为0
      v.stockQuantity = 0
      if (v.productType !== 3) {
        // 普通商品和oem商品，增加一个restQuantity 用来判断直发时能否勾选
        v.restQuantity = stock?.total ?? 0
      } else {
        // 组合商品需等待子商品剩余库存计算好后
      }
    }
  }
  const GpRestQuantity = (item:Sku) => {
    const nolimit = item.combinationProductItemList.every(v => {
      return v.productStatus === 0
    })
    if (nolimit) {
      item.restQuantity = 9999999
    } else {
      const limit = item.combinationProductItemList.reduce((limit, v) => {
        return Math.min(Math.floor(v.restQuantity / v.unitNums), limit)
      }, 9999999)
      item.restQuantity = limit
    }
  }
  // 用于判断oem商品是否可下单
  const hasOemQty = (v:Sku) => {
    const qty = listCheckMap[v.cartId] ? v.stockQuantity : v.restQuantity
    // 先去掉oem库存校验
    return false
    // return mode && qty < v.orderQuantity
  }

  // 子商品库存数
  await getSubStock()
  //
  list.forEach((shop:Shop) => {
    const { cartList } = shop
    cartList.forEach(v => {
      // 1. 计算商品使用数
      calcStockQty(v, v.cartId)
      if (v.productType === 3) {
        // 1.5 组合商品是唯一的，可以先分配组合商品库存
        deviceStockQty(v)
        const gp = v
        // 2. 只有先分配主商品库存后，才计算子商品订单数
        const num = mode ? Math.max(0, gp.orderQuantity - gp.stockQuantity) : gp.orderQuantity
        v.combinationProductItemList.forEach((sub:any) => {
          const { cartId } = v
          // 加入子商品
          if (sub.shopProductSku) {
            // 3. 组合商品的子商品添加到库存查询列表
            // if (!stockMap[sub.shopProductSku]) {
            //   batch.add(sub.shopProductSku)
            // }
            sub.cartId = cartId
            sub.orderQuantity = sub.unitNums * num
            sub.valueQuantity = sub.unitNums * gp.orderQuantity
            // 4. 计算子商品使用数
            calcStockQty(sub, cartId)
          }
        })
      } else if (JSON.parse(v.paymentDetail as string)?.length) {
        v.curPdtPirce = Number((JSON.parse(v.paymentDetail as string)?.[0].paymentPeriod * v.valuePrice))
      }
    })
  })
  // 失效商品标识 黑名单商品
  const invalidFlag = (item:any) => {
    return item.productStatus === 1 || item.productStatus === 2 || item.blackTag === 1
  }
  /** 失效商品 */
  const hasInvalid = (item:any) => {
    delete item.shitProp
    const qty = listCheckMap[item.cartId] ? item.stockQuantity : item.restQuantity
    if (mode === 0) {
      // 囤货
      item.shitProp = invalidFlag(item)
      listCheckMap[item.cartId] && (listCheckMap[item.cartId] = !item.shitProp)
    } else {
      // 直发
      if (item.orderQuantity > qty && invalidFlag(item)) {
        // 商品异常并且库存不足
        item.shitProp = true
        listCheckMap[item.cartId] = false
      } else {
        item.shitProp = false
      }
      // 如果没有勾选，失效商品按照勾选后的剩余库存展示是否置灰
      if (mode && !listCheckMap[item.cartId] && invalidFlag(item)) {
        item.shitProp = item.orderQuantity > qty
        listCheckMap[item.cartId] = false
      }
    }
    // 如果item.productStatus === 4 店铺未授权 商品置灰
    if (item.productStatus === 4 || item.productStatus === 5) {
      item.shitProp = true
      listCheckMap[item.cartId] = false
    }
  }
  const skuList = list.reduce((acc: Sku[], v: Shop) => {
    const { cartList } = v
    // 5. 分配使用库存，组合商品不必再计算库存
    cartList.forEach(v => {
      if (v.productType !== 3) {
        deviceStockQty(v)
      }
    })
    //
    const gp: any = cartList[0]
    if (gp.productType === 3) {
      gp.buyQuantity = Math.max(0, gp.orderQuantity - (gp.matchStore ? gp.stockQuantity : (mode ? gp.stockQuantity : 0)))
      group.push(gp)
      gp.shitProp = false
      gp.combinationProductItemList.forEach((item: any) => {
        groupGoods.push(item)
        // 子商品计算库存
        deviceStockQty(item)
        // 囤货组合商品不校验失效商品
        if (mode !== 0) {
          // 子商品中含有oem商品且库存不足，则子商品不可直发
          if (item.productType === 2 && hasOemQty(item)) {
            gp.shitProp = true
            listCheckMap[gp.cartId] = false
          } else if (item.productType === 1) {
            hasInvalid(item)
            if (item.shitProp) {
              gp.shitProp = true
              listCheckMap[gp.cartId] = false
            }
          }
        }
        item.cartAdditionList = item.additionList ?? []
        item.matchStore = null
        // 注意：这里传的是组合商品的shopProductSku，不是子商品的
        item.combinationProductSku = gp.shopProductSku
      })
      // 6. 计算组合的剩余库存数
      GpRestQuantity(gp)
      acc = acc.concat(gp.combinationProductItemList)
    } else {
      // 如果是直发，OEM商品数量必须小于库存数，否则置灰不可选
      if (gp.productType === 2) {
        cartList.forEach((oem: any) => {
          if (hasOemQty(oem)) {
            oem.shitProp = true
            listCheckMap[oem.cartId] = false
          } else {
            oem.shitProp = false
          }
          // oem样品单不算入阶梯价
          if ([1, 3].includes(oem.oemOrderType)) {
            delete oem.productCode
          }
        })
      }
      if (gp.productType === 1) {
        // 普通商品
        cartList.forEach((item:any) => {
          hasInvalid(item)
        })
      }
      acc = acc.concat(cartList)
    }
    return acc
  }, [])
  return [skuList, group, groupGoods]
}

// 组合商品匹配落单库存
const cache: any = {
  params: new Set(),
  req: null
}
export const setStock = async (
  groupGoods: any,
  checkMap: any,
  mode:number
): Promise<any> => {
  const params: any = new Set()
  const goods = groupGoods.filter((v: Sku) => checkMap[v.cartId])
  if (!goods.length) return []
  goods.forEach((v: any) => {
    params.add(v.shopProductSku)
  })
  // 获取待转结sku数
  // if (![...params].every((v) => cache.params.has(v))) {
  if (mode && params.size) {
    cache.params = params
    cache.req = getRestGroupGoods({ shopProductSkuList: [...params] }).then(
      (res) => res.data
    )
  }
  const rest = await cache.req.then((data: any) =>
    data.map((v: any) => {
      return {
        ...v,
        combinationProductSku: null,
        time: getJapanTime(v.remainCombinationCloseTime, 'YYYY-MM-DD HH:mm')
      }
    })
  )
  const restmap = arr2map(rest, (v: any) => v.shopProductSku)
  // 匹配转结数
  goods.forEach((v: Sku) => {
    const { shopProductSku } = v
    const r = restmap.get(shopProductSku)
    // 只有少于订单数才匹配转接数
    if (mode && r && r.remainCombinationQuantity <= v.orderQuantity) {
      r.combinationProductSku = v.combinationProductSku
      // 修改子商品数量
      v.stockQuantity = r.remainCombinationQuantity
      v.matchStore = r
      restmap.delete(shopProductSku)
    }
  })
  return rest
}

// 计算组合的商品总价、附加项总价和发货附加项总价
export const calcGp = async (group: any, mode: any): Promise<void> => {
  await Promise.all(group.map(async (v: any) => {
    let totalPrice = 0
    let adtPrice = mode ? 0 : (v.combinationProductAdditionList ? await calcGpAdt(v, 0, sourceCountryRef.value) : 0)
    let valuePrice = 0
    let curPdtPirce = 0
    v.additionNameJpSummary = v.combinationProductAdditionList ? v.combinationProductAdditionList.map((adt:any) => adt.additionNameJp).join() : null
    v.combinationProductItemList.forEach((v: any) => {
      totalPrice += v.totalPrice
      adtPrice += v.adtPrice
      valuePrice += v.valuePrice
      curPdtPirce += v.curPdtPirce
    })
    v.adtPrice = adtPrice
    v.totalPrice = totalPrice
    v.price = v.totalPrice / (mode ? v.buyQuantity : v.orderQuantity)
    v.valuePrice = valuePrice
    v.curPdtPirce = curPdtPirce
  }))
}
